<template>
    <GuideStep3Component
        type="ABTEST"
        roleKey="experienceAdd"
        :step="props.step"
        :content="$t('guide.guide_popover_step_8_desc')"
        :buttonText="$t('guide.guide_popover_step_8_btn_create')"
        :templateTitle="$t('experience.common.ab_template_title')"
        componentName="ExperienceABTestTypeSelect"
    ></GuideStep3Component>
</template>

<script lang="ts" setup>
import GuideStep3Component from './GuideStep3Component.vue';
import { GuideStep } from '@master/store/guide.store';

interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();
</script>

<style lang="scss" module>
@import '@style/import.scss';
</style>
